import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import Employees from './pages/Employees';
import TaskReport from './pages/TaskReport';
import ResourceView from './pages/ResourceView';
import WeeklyView from './pages/WeeklyView';
import DynamicAllocation from './pages/DynamicAllocation';
import ChangeRequests from './pages/ChangeRequests';
import RAID from './pages/RAID';
import Users from './pages/Users';
import './App.css';

const AppRoutes = () => {
  const { user, can } = useAuth();

  // Not logged in → Login page
  if (!user) return <Login />;

  // Logged in but must reset password → ResetPassword page
  if (user.must_reset_password) return <ResetPassword />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to={can('viewDashboard') ? '/dashboard' : '/projects'} replace />} />
        <Route path="/dashboard"      element={can('viewDashboard')    ? <Dashboard />        : <Navigate to="/projects" replace />} />
        <Route path="/projects"       element={<Projects />} />
        <Route path="/projects/:id"   element={<ProjectDetail />} />
        <Route path="/plans"          element={can('createEditProject') ? <Plans />      : <Navigate to="/projects" replace />} />
        <Route path="/plans/:id"      element={can('createEditProject') ? <PlanDetail /> : <Navigate to="/projects" replace />} />
        <Route path="/employees"      element={can('manageEmployees')  ? <Employees />        : <Navigate to="/projects" replace />} />
        <Route path="/tasks/report"   element={can('viewTaskReport')   ? <TaskReport />       : <Navigate to="/projects" replace />} />
        <Route path="/resources"      element={can('viewResources')    ? <ResourceView />     : <Navigate to="/projects" replace />} />
        <Route path="/weekly"         element={can('viewResources')    ? <WeeklyView />       : <Navigate to="/projects" replace />} />
        <Route path="/allocation"     element={can('viewAllocation')   ? <DynamicAllocation /> : <Navigate to="/projects" replace />} />
        <Route path="/allocation/:employeeId" element={can('viewAllocation') ? <DynamicAllocation /> : <Navigate to="/projects" replace />} />
        <Route path="/change-requests" element={can('manageChanges')   ? <ChangeRequests />   : <Navigate to="/projects" replace />} />
        <Route path="/raid"           element={can('manageRAID')       ? <RAID />             : <Navigate to="/projects" replace />} />
        <Route path="/users"          element={can('manageUsers')      ? <Users />            : <Navigate to="/projects" replace />} />
        <Route path="*"               element={<Navigate to="/projects" replace />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
